var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l(([1, 2, 3, 4, 5]),function(val){return _c('i',{key:val,staticClass:"fs-xl fa",class:_vm.starClass(val)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }